import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { verifyInviteOtp } from '@/api/invites.api';
import { completeVerifiedOutcome } from '@/lib/auth/complete-verified-outcome';

/**
 * Invite-accept OTP-verification mutation, step 2 of 2 (US-038/US-098), now
 * only for the resume branch of an existing unverified account (FR-208).
 * Mirrors `useVerifyEmail`: on success the backend finally issues the
 * session (membership + invite-accepted are created at this step), so we
 * persist the token, seed the auth cache, and route to the shared
 * verified-success screen.
 */
export function useVerifyInviteOtp(token: string) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof verifyInviteOtp>[1]) => verifyInviteOtp(token, payload),
    onSuccess: (outcome) => completeVerifiedOutcome(outcome, { queryClient, navigate }),
  });
}
